import { MenuTypes } from './items';
export const slashMenuCommand = ({ editor, range, props, }) => {
    var _a;
    // increase range.to by one when the next node is of type "text"
    // and starts with a space character
    const { nodeAfter } = editor.view.state.selection.$to;
    const overrideSpace = (_a = nodeAfter === null || nodeAfter === void 0 ? void 0 : nodeAfter.text) === null || _a === void 0 ? void 0 : _a.startsWith(' ');
    if (overrideSpace) {
        range.to += 1;
    }
    let op = editor
        .chain()
        .focus()
        .command(({ tr }) => {
        tr.insertText('', range.from, range.to);
        return true;
    });
    switch (props.type) {
        case MenuTypes.BulletList:
            op = op.toggleBulletList();
            break;
        case MenuTypes.Blockquote:
            op = op.toggleBlockquote();
            break;
        case MenuTypes.CodeBlock:
            op = op.toggleCodeBlock();
            break;
        case MenuTypes.NumberedList:
            op = op.toggleOrderedList();
            break;
        case MenuTypes.Emoji:
            op = op.insertContent(':');
            break;
        case MenuTypes.Mention:
            op = op.insertContent('@');
            break;
        case MenuTypes.LargeHeader:
            op = op.toggleHeading({ level: 2 });
            break;
        case MenuTypes.MediumHeader:
            op = op.toggleHeading({ level: 3 });
            break;
        default:
            break;
    }
    op.run();
};
//# sourceMappingURL=click-handler.js.map